import { render, staticRenderFns } from "./SavingIndicator.vue?vue&type=template&id=2b61d89d"
import script from "./SavingIndicator.vue?vue&type=script&lang=js"
export * from "./SavingIndicator.vue?vue&type=script&lang=js"
import style0 from "./SavingIndicator.vue?vue&type=style&index=0&id=2b61d89d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports